import { SyntheticEvent } from 'react';

import { TParsedProductInstance } from '@lib/core/products/types';
import { HARDCODED_PRODUCT_RATE_DATA } from '@lib/core/service/consts';
import { localeCommon } from '@lib/tools/locale/source/web/common';
import { useModals } from '@lib/tools/modals/hooks';
import { MODALS } from '@lib/tools/shared/helpers/consts';

import startIconDefault from '@components/web/src/assets/icons/productRate/rating_start_icon.svg';
import startIconLight from '@components/web/src/assets/icons/productRate/rating_start_icon_light.svg';
import { RatingTooltip } from '@components/web/src/atoms/ProductRating/ProductRating/RatingTooltip';
import * as S from '@components/web/src/atoms/ProductRating/ProductRating/styles';
import { ProductRateModal } from '@components/web/src/templates/Modals/ProductRateModal/ProductRateModal';

export type TFeedbackIconSizes = 'small' | 'medium' | 'large';

interface Props {
  size?: TFeedbackIconSizes;
  variant?: 'default' | 'light';
  parsedProductInstanceData?: TParsedProductInstance;
  isFeedbackModalDisabled?: boolean;
  isProductCardTooltip?: boolean;
  shouldShowFeedbackTooltip?: boolean;
  handleRedirectToRegistrationPage?: () => void;
}

export const RatingButton = ({
  size = 'small',
  variant = 'default',
  parsedProductInstanceData,
  isFeedbackModalDisabled = false,
  isProductCardTooltip = false,
  shouldShowFeedbackTooltip,
}: Props) => {
  const { isFeedbackModalOpen, openFeedbackModal, closeFeedbackModal, handleToggleModal } = useModals();

  const handleButtonClick = (e: SyntheticEvent) => openFeedbackModal(e);

  const { productRate, productRateOptions, handleUpdateProductRating, isProductRateUpdateLoading } =
    parsedProductInstanceData || {};

  const { tasteId } = localeCommon;
  const isLightVariant = variant === 'light';
  const startIcon = isLightVariant ? startIconLight : startIconDefault;
  const icon =
    productRate?.image || productRate?.rateValue
      ? HARDCODED_PRODUCT_RATE_DATA[productRate?.rateValue]?.icon.activeIcon
      : startIcon;

  const isShowFeedbackTooltip = shouldShowFeedbackTooltip && !productRate;

  return (
    <>
      <S.RatingButton $isLightVariant={isLightVariant} onClick={handleButtonClick}>
        <S.RatingImage $size={size} alt="rate icon" src={icon} />
        <RatingTooltip
          isAnimated
          infoText={tasteId.tasteIdTooltipText}
          isProductCardTooltip={isProductCardTooltip}
          isShowTooltip={isShowFeedbackTooltip}
        />
      </S.RatingButton>

      {isFeedbackModalOpen && parsedProductInstanceData && !isFeedbackModalDisabled && (
        <ProductRateModal
          handleOpenDiscoveryQuizModal={() => handleToggleModal(MODALS.DISCOVERY_QUIZ_MODAL)}
          handleUpdateProductRating={handleUpdateProductRating}
          hideModal={() => closeFeedbackModal()}
          isLoading={isProductRateUpdateLoading}
          isModalOpen={isFeedbackModalOpen}
          parsedProductInstanceData={parsedProductInstanceData}
          productRateOptions={productRateOptions}
        />
      )}
    </>
  );
};
